import React from 'react';
import { Box, Typography } from '@material-ui/core';

const SectionDivider: React.FC<{ label?: string }> = ({ label }) => {
    if (!label) {
        return (
            <Box style={{ height: 1, background: '#e8eaed', width: '100%', margin: '16px 0' }} />
        );
    }

    return (
        <Box style={{ display: 'flex', alignItems: 'center', gap: 14, margin: '20px 0' }}>
            <Box style={{ flex: 1, height: 1, background: '#e8eaed' }} />
            <Typography
                style={{
                    fontSize: 11,
                    fontWeight: 700,
                    letterSpacing: '0.1em',
                    color: '#adb5bd',
                    textTransform: 'uppercase'
                }}>
                {label}
            </Typography>
            <Box style={{ flex: 1, height: 1, background: '#e8eaed' }} />
        </Box>
    );
};

export default SectionDivider;
